
import React from 'react';

interface ReviewStarsProps {
  rating: number;
}

export function ReviewStars({ rating }: ReviewStarsProps) {
  const renderRatingStars = (rating: number) => {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  return (
    <span className="text-[#00dd00] font-bold">{renderRatingStars(rating)}</span>
  );
}
